import QueryString from "qs";

import AxiosInstance from "./axiosInstance.js";

const getBaseURL = () => process.env.REACT_APP_URL + "/advisor/api/v1/";

export function getRequest(url, params) {
  return AxiosInstance.get(url, params);
}

export function getRequestWithAuthorization(url, authorization, i18n) {
  const common = {
    Authorization: `Basic ${authorization}`,
    "Accept-Language": i18n.language || "en-US",
  };
  AxiosInstance.defaults.headers.common = common;
  return AxiosInstance.get(url);
}

export function updateLanguageInHeaders(language) {
  AxiosInstance.defaults.headers.common["Accept-Language"] =
    language || "en-US";
}

export function postRequest(url, payload, config = {}) {
  return AxiosInstance.post(url, payload, config).then((response) => {
    // If responseType is blob, return the full response
    if (config.responseType === "blob") {
      return response;
    }
    const responseData = response.data || response;
    // Add status to the response data while preserving existing structure
    if (typeof responseData === "object" && responseData !== null) {
      return {
        ...responseData,
        status: response.status,
      };
    }
    return responseData;
  });
}

export function putRequest(url, payload) {
  return AxiosInstance.put(url, payload).then((response) => {
    const responseData = response.data || response;
    // need to uncomment and check all put requests
    // if (typeof responseData === "object" && responseData !== null) {
    //   return {
    //     ...responseData,
    //     status: response.status,
    //   };
    // }
    return responseData;
  });
}

export function deleteRequest(url, data = {}) {
  return AxiosInstance.delete(url, { data }).then(
    (response) => response.data || response
  );
}

export function patchRequest(url, payload, isAdminAPI = false) {
  url = isAdminAPI ? url : `${getBaseURL()}${url}`;
  return AxiosInstance.patch(url, payload).then(
    (response) => response.data || response
  );
}

export const paramsSerializer = (params) =>
  QueryString.stringify(params, { arrayFormat: "repeat" });
